import React from "react";

const AttendenceIcon = (props:any) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          d="M13.4302 11.5326C13.2434 11.3121 11.8483 9.72793 9.54631 9.72793C7.33436 9.73018 5.96174 11.1973 5.70972 11.4673C5.47795 11.7149 5.31143 11.9444 5.20117 12.1109M5.87623 17.2526C6.03825 17.2909 6.20251 17.3269 6.36453 17.3651C8.46171 17.8489 10.6287 17.8489 12.7258 17.3651L14.1345 17.0411C14.1682 17.0343 14.1997 17.0276 14.2335 17.0208M5.72772 6.34363C5.72772 5.62807 5.89648 4.926 6.21601 4.3027C6.53554 3.67939 6.99683 3.1551 7.55263 2.78156C8.11068 2.40803 8.74524 2.19876 9.40005 2.16951C10.0526 2.14251 10.7007 2.29777 11.2835 2.62405C11.8663 2.95033 12.3613 3.43187 12.7236 4.02817C13.0859 4.62223 13.3019 5.31079 13.3536 6.02185C13.4032 6.73517 13.2861 7.45073 13.0116 8.09879C12.7371 8.74684 12.3141 9.3094 11.7853 9.72793C11.0832 9.37915 10.3181 9.19914 9.54631 9.19914C8.74749 9.19914 7.98917 9.38815 7.30736 9.72793C6.81682 9.3409 6.41853 8.83235 6.14401 8.2428C5.86948 7.6555 5.72547 7.00519 5.72772 6.34363Z"
          stroke={props?.color ?? "black"}
          stroke-width="0.833333"
          stroke-miterlimit="10"
        />
        <path
          d="M4.38201 13.1284V14.8543L5.4666 15.4303M5.19883 12.1113C6.29693 12.4781 7.0935 13.5672 7.0935 14.8543C7.0935 16.4429 5.87839 17.73 4.37976 17.73C2.88112 17.73 1.66602 16.4429 1.66602 14.8543C1.66602 13.2656 2.88112 11.9785 4.37976 11.9785C4.66778 11.9785 4.94231 12.0235 5.19883 12.1113Z"
          stroke={props?.color ?? "black"}
          stroke-width="0.833333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.4388 11.5284C13.7718 11.3731 14.1409 11.2876 14.5302 11.2876C16.0288 11.2876 17.2439 12.5747 17.2439 14.1634C17.2439 15.752 16.0288 17.0391 14.5302 17.0391C13.0315 17.0391 11.8164 15.752 11.8164 14.1634C11.8142 12.9865 12.4825 11.9739 13.4388 11.5284Z"
          stroke={props?.color ?? "black"}
          stroke-width="0.833333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.2125 12.9551L13.933 15.1985C13.6428 14.8925 13.3547 14.5842 13.0645 14.2782"
          stroke={props?.color ?? "black"}
          stroke-width="0.833333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export default AttendenceIcon;
